enum ChangeReasonEnum {
	Temporary = 'Temporary',
	NewLowerPrice = 'NewLowerPrice',
	TimeRestrictedOffer = 'TimeRestrictedOffer',
	Discontinued = 'Discontinued'
}

export default ChangeReasonEnum;
